<template>
  <bean-source-page
    :type="type"
    :columns="columns"
    :form-columns="formColumns"
    :filter-columns="filterColumns"
    :form="form"
    :title="$t('model.booking')"
    resource="bookings"
    :actions="actions"
    :batch-actions="batchActions"
  />
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator';
import { filterColumnsExtend, columnsExtend, formColumnsExtend } from '../admin_grapes/bookings.js';
import _ from 'lodash';

@Component
export default class Bookings extends Vue {
  @Prop(String) type;

  // form 新建表单初始化数据（default数据）
  form = {}

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - page type enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -RESTful api resource name
   */
  filterColumns() {
    const array = [
      'reference_cont',
      'status_eq',
      'user_id_eq',
      { key: 'created_at_gteq', label: '创建时间大于等于' },
      { key: 'created_at_lteq', label: '创建时间小于等于' },
    ].filter(Boolean)

    return filterColumnsExtend(array)
  }

  boundRenderCell(bound) {
    let data = []
    _.each(bound, (item) => {
      _.each(item.products, (product) => {
        data = data.concat({
          origin: item.origin.name,
          destination: item.destination.name,
          timing: `${item.timing.departureDate} ${item.timing.departs} \n ${item.timing.arrivalDate} ${item.timing.arrives}`,
          passengerId: product.passengerId,
          priceWithCurrency: product.priceWithCurrency,
          classOfAccommodation: _.get(item, 'classOfAccommodation.code') || product.code,
          isCancelled: product.isCancelled ? '是' : '否',
          cancellationReason: product.cancellationReason === 'Exchange' ? '改签' : null,
          serviceType: item.serviceType.name,
          itemRef: product.itemRef,
          afterSalesRules: product.afterSalesRules.map((rule) => {
            return {
              type: rule.type,
              price: rule.price,
              active: rule.active ? '是' : '否',
              reasonCode: rule.reasonCode,
              validUntil: rule.validUntil
            }
          })
        }).sort((a, b) => {
          return a.itemRef - b.itemRef;
        });
      })
    })

    return (
      <el-table data={data}>
        <el-table-column prop="itemRef" label="Item Ref"></el-table-column>
        <el-table-column prop="origin" label="始发站"></el-table-column>
        <el-table-column prop="destination" label="终点站"></el-table-column>
        <el-table-column prop="timing" width="140" label="时间"></el-table-column>
        <el-table-column prop="passengerId" width="110" label="乘客ID"></el-table-column>
        <el-table-column prop="priceWithCurrency" label="价格"></el-table-column>
        <el-table-column prop="classOfAccommodation" label="舱位"></el-table-column>
        <el-table-column prop="isCancelled" label="已取消" scopedSlots={{
          default: (scope) => {
            if (scope.row.isCancelled === '是') {
              return (
                <el-popover width="200" trigger="hover">
                  <p>取消原因: {scope.row.cancellationReason}</p>
                  <el-button slot="reference" type="text" size="mini">{scope.row.isCancelled}</el-button>
                </el-popover>
              )
            } else {
              return <span>{scope.row.isCancelled}</span>
            }
          }
        }}
        ></el-table-column>
        <el-table-column prop="serviceType" label="服务商"></el-table-column>
        <el-table-column label="售后规则" scopedSlots={{
          default: (scope) => {
            return (
            <el-popover width="800" trigger="click" placement="top-start">
              <el-table data={scope.row.afterSalesRules}>
                <el-table-column prop="type" label="类型"></el-table-column>
                <el-table-column prop="price" label="价格"></el-table-column>
                <el-table-column prop="active" label="是否激活"></el-table-column>
                <el-table-column prop="reasonCode" label="原因码"></el-table-column>
                <el-table-column prop="validUntil" label="有效期"></el-table-column>
              </el-table>
              <el-button slot="reference" type="text" size="mini">查看</el-button>
            </el-popover>
            );
          }
        }}></el-table-column>
      </el-table>
    )
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - page type enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -RESTful api resource name
   */
  columns(h, { type }) {
    const array = [
      type === 'show' && 'id',
      'reference',
      {
        prop: 'total_price_with_currency',
        label: '金额',
        renderCell: (h, { props: { scope: { row } } }) => {
          return <span>{row.response.totalPriceWithCurrency}</span>
        }
      },
      'real_pay_amount',
      'status',
      {
        prop: 'refund_state',
        label: '退款状态',
        renderCell: (h, { props: { scope: { row } } }) => {
          return <span>{this.$t(`refundState.${row.refund_state}`)}</span>
        }
      },
      {
        prop: 'last_refund_payment_status',
        label: '最新退款状态',
        renderCell: (h, { props: { scope: { row } } }) => {
          return <span>{row.last_refund_payment_status ? this.$t(`refundPaymentStatus.${row.last_refund_payment_status}`) : '' }</span>
        }
      },
      'user',
      type === 'show' && {
        prop: 'customer_email',
        label: '联系人邮箱',
        renderCell: (h, { props: { scope: { row } } }) => {
          return <span>{_.get(row.response, 'customer.email')}</span>
        }
      },
      // type === 'show' && {
      //   prop: 'customer_first_name',
      //   label: '联系人名称',
      //   renderCell: (h, { props: { scope: { row } } }) => {
      //     return <span>{_.join(_.filter([_.get(row.response, 'customer.firstName'), _.get(row.response, 'customer.lastName')]), ' ')}</span>
      //   }
      // },
      type === 'show' && {
        prop: 'customer_phone',
        label: '联系人电话',
        renderCell: (h, { props: { scope: { row } } }) => {
          let str = _.get(row.response, 'customer.phoneNumber')

          if (_.get(row.response, 'customer.phoneCountryCode')) {
            str = `${_.get(row.response, 'customer.phoneCountryCode')} ${str}`
          }

          return <span>{str}</span>
        }
      },
      type === 'show' && {
        prop: 'passengers',
        label: '乘客',
        renderCell: (h, { props: { scope: { row } } }) => {
          const readyToTravels = row.response['readyToTravel']
          const data = _.map(row.response['passengers'], (passenger) => {
            if (readyToTravels) {
              passenger.readyToTravel = readyToTravels.find((item) => item.passengerUUID === passenger.uuid).readyToTravel ? '是' : '否'
            } else {
              passenger.readyToTravel = '/'
            }

            return {
              id: passenger.id,
              type: this.$t(`passengerType.${passenger.type}`),
              email: passenger.email,
              name: _.join([passenger.firstName, passenger.lastName], ' '),
              phone: passenger.unformattedPhoneNumber ? `${passenger.unformattedPhoneNumber.countryCode} ${passenger.unformattedPhoneNumber.number}` : null,
              readyToTravel: passenger.readyToTravel
            }
          })

          return (
            <el-table data={data}>
              <el-table-column prop="id" label="乘客ID"></el-table-column>
              <el-table-column prop="name" label="名称"></el-table-column>
              <el-table-column prop="type" label="类型"></el-table-column>
              <el-table-column prop="email" label="邮箱"></el-table-column>
              <el-table-column prop="phone" label="电话"></el-table-column>
              <el-table-column prop="readyToTravel" label="已提交资料"></el-table-column>
            </el-table>
          )
        }
      },
      type === 'show' && {
        prop: 'outbound',
        label: '去程',
        renderCell: (h, { props: { scope: { row } } }) => {
          return this.boundRenderCell(row.response['outbound'])
        }
      },
      type === 'show' && {
        prop: 'inbound',
        label: '返程',
        renderCell: (h, { props: { scope: { row } } }) => {
          return this.boundRenderCell(row.response['inbound'])
        }
      },
      type === 'show' && {
        prop: 'payments',
        label: '支付清单',
        renderCell: (h, { props: { scope: { row } } }) => {
          const booking_id = row.id;
          const data = _.map(row.payments, (payment) => {
            const amount = payment.amount_in_cent / 100;
            return {
              id: payment.id,
              transaction_id: payment.transaction_id,
              amount: payment.type === 'ChargePayment' ? amount : -amount,
              status: payment.status,
              completed_at: payment.completed_at,
              customer_token: payment.customer_token,
              merchant_token: payment.merchant_token,
              refund_item_ref: payment.refund_item_ref,
              type: payment.type
            }
          })

          return (
            <el-table data={data}>
              <el-table-column prop="id" label="ID"></el-table-column>
              <el-table-column prop="transaction_id" label="Transaction ID"></el-table-column>
              <el-table-column prop="amount" label="金额"></el-table-column>
              <el-table-column prop="status" label="状态"></el-table-column>
              <el-table-column prop="Token" label="Token" scopedSlots={{
                default: (scope) => {
                  return (
                    <el-popover width="200" trigger="hover">
                      <p>Customer Toke: {scope.row.customer_token}</p>
                      <p>Merchant Toke: {scope.row.merchant_token}</p>
                      <el-button slot="reference" type="text" size="mini">查看</el-button>
                    </el-popover>
                  )
                }
              }}></el-table-column>
              <el-table-column prop="completed_at" label="完成时间"></el-table-column>
              <el-table-column prop="refund_item_ref" label="退款项"></el-table-column>
              <el-table-column label="操作" scopedSlots={{
                default: (scope) => {
                  console.info(scope.row);
                  if (scope.row.type === 'RefundPayment' && !scope.row.transaction_id) {
                    return (
                      <el-button
                        type="primary"
                        size="mini"
                        onClick={() => {
                          this.$confirm('确认手动申请退款吗？<br><br>1. 手动退款前先确认账户有余额<br>2. 退款流程需要时间，请勿在短时间内多次触发<br>3. 建议登录Payxpert后台查看退款状态', '提示', {
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                            type: 'warning',
                            dangerouslyUseHTMLString: true
                          }).then(async () => {
                            await this.$autoLoading(
                              this.$request.put(`/bookings/${booking_id}/refund_and_query`, {
                                refund_payment_id: scope.row.id
                              })
                            );
                            this.$message.success(this.$t('operateSuccess'));
                            location.reload();
                          }).catch(() => {
                          });
                        }}>
                        退款
                      </el-button>
                    )
                  }
                  return null;
                }
              }}></el-table-column>
            </el-table>
          )
        }
      },
      type === 'show' && {
        prop: 'eurostar_payments',
        label: 'EuroStar 流水',
        renderCell: (h, { props: { scope: { row } } }) => {
          const data = _.map(row.response['payments'], (payment) => {
            return {
              id: payment.id,
              currency: payment.currency,
              amountWithCurrency: payment.amountWithCurrency,
              method: payment.method,
              reference: payment.reference,
              currencyRate: payment.currencyRate,
              paymentStatus: payment.paymentStatus,
              transactionTimestamp: payment.transactionTimestamp
            }
          })

          return (
            <el-table data={data}>
              <el-table-column prop="currency" label="货币"></el-table-column>
              <el-table-column prop="amountWithCurrency" label="金额"></el-table-column>
              <el-table-column prop="method" label="Method"></el-table-column>
              <el-table-column prop="reference" label="支付单号"></el-table-column>
              <el-table-column prop="currencyRate" label="汇率"></el-table-column>
              <el-table-column prop="paymentStatus" label="状态"></el-table-column>
              <el-table-column prop="transactionTimestamp" label="时间"></el-table-column>
            </el-table>
          )
        }
      },
      type === 'show' && 'created_at',
      type === 'show' && 'updated_at',
    ].filter(Boolean)

    return columnsExtend(array)
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - page type enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource - RESTful api resoure name
   * @param {Object} params.data - current form data
   * @param {Function} params.change - invoke this method to sync form change({ field: 'new value' })
   */
  formColumns(h, { data, type }) {
    const array = [

    ].filter(Boolean)

    return formColumnsExtend(array, { data: data, type: type })
  }

  /**
   * @param {Object} scope -页面/表格 scope 数据
   * @param {Object} scope.row - 详情页/表格行 数据
   * @param {Object} sourcePageScope
   * @param {Function} sourcePageScope.remove - sourcePage删除方法
   * @param {Function} sourcePageScope.reload - sourcePage重新请求页面数据
   */
  actions({ row }, { reload }) {
    return [
      // {
      //   component: 'routeButton',
      //   props: {
      //     label: this.$t('edit'),
      //     to: { name: 'bookings.edit', params: { id: row.id } }
      //   }
      // },
      // {
      //   component: 'confirmButton',
      //   props: {
      //     label: this.$t('destroy'),
      //     type: 'danger',
      //     can: 'bookings.destroy'
      //   },
      //   on: {
      //     confirm: () => remove(row.id)
      //   }
      // },
     {
        component: 'confirmButton',
        props: {
          label: this.$t('actions.syncEurostarData'),
          can: 'bookings.update',
          ype: 'primary'
        },
        on: {
          confirm: async () => {
            await this.$autoLoading(this.$request.put(`/bookings/${row.id}/sync_eurostar_data`));
            this.$message.success(this.$t('operateSuccess'));
            reload();
          }
        }
      },
      {
        component: 'routeButton',
        props: {
          label: '请求日志',
          to: { name: 'request_logs.index', query: { target_id_eq: row.reference } }
        }
      },
    ].filter(Boolean);
  }

      /**
  * @param {Object} scope -表格 scope 数据
  * @param {Object} scope.selection - 表格已选择行数据
  * @param {Object} sourcePageScope
  * @param {Function} sourcePageScope.remove - sourcePage删除方法
  * @param {Function} sourcePageScope.reload - sourcePage重新请求页面数据
  */
  batchActions({ selection }, { resource }) {
    const exportClick = async (selection) => {
      if (selection.length === 0) {
        await this.$request.get(`/${resource}/export`, { ...this.$route.query });
      } else {
        await this.$request.get(`/${resource}/export`, { ...this.$route.query, id_in: _.map(selection, item => item.id) });
      }

      this.$message.success(this.$t('exporting'));
    }

    return [
      () => <el-button type='primary' onClick={() => exportClick(selection)}><i class='el-icon-download'></i>{this.$t('export')}</el-button>
    ];
  }
}

export const route = [
  {
    path: '/bookings',
    name: 'bookings.index',
    component: Bookings,
    props: {
      type: 'index',
    }
  },
  {
    path: '/bookings/new',
    name: 'bookings.new',
    component: Bookings,
    props: {
      type: 'new',
    }
  },
  {
    path: '/bookings/:id',
    name: 'bookings.show',
    component: Bookings,
    props: {
      type: 'show',
    }
  },
  {
    path: '/bookings/:id/edit',
    name: 'bookings.edit',
    component: Bookings,
    props: {
      type: 'edit'
    }
  }
]
</script>
